<script>
    import {link} from 'svelte-spa-router'
    import {filter} from "../js/stores";

    let brands = [
        [
            "Aeolus",
            "Altaishina",
            "Apollo",
            "Arivo",
            "Atturo",
            "Avon",
            "Barum",
            "BFGoodrich",
            "Bie¿nikowane Profil",
            "Bridgestone",
            "Ceat",
            "Chengshan",
            "CHINSKIE",
            "Comforser",
            "Continental",
            "Cooper",
            "CST",
            "Cultor",
            "Daewoo",
        ],
        [
            "Dayton",
            "Diamondback",
            "Diplomat",
            "Dunlop",
            "Dębica",
            "ERACLE",
            "Falken",
            "Federal",
            "Firestone",
            "Formula",
            "Fortune",
            "Fulda",
            "General",
            "Gislaved",
            "Giti",
            "Goodride",
            "Goodyear",
            "Gremax",
            "Gripmax",

        ],
        [
            "GT Radial",
            "GTK",
            "Hankook",
            "Hifly",
            "Hubtrac",
            "Imperial",
            "Infinity",
            "Interstate",
            "Kabat",
            "Kama",
            "Kenda",
            "Kinforest",
            "Kleber",
            "Kormoran",
            "Kumho",
            "Lanvigator",
            "Lapponia",
            "Lassa",
            "Laufenn",
        ],
        [
            "Linglong",
            "Long March",
            "Marshal",
            "Matador",
            "Maxam",
            "Maxxis",
            "Metzeler",
            "Michelin",
            "Minerva",
            "Mirage",
            "Mitas",
            "MRL",
            "Nankang",
            "Nexen",
            "Nokian",
            "Nortec",
            "Ovation",
            "Ozka",
            "Pace",
        ],
        [
            // "Paxaro",
            "Petlas",
            "Pirelli",
            "Powertrac",
            "Riken",
            "Roadmarch",
            "Roadstone",
            "Routeway",
            "Rovelo",
            "Saetta",
            "Sailun",
            "Sava",
            "Semi-Pro",
            "Semperit",
            "Solideal",
            "Starfire",
            "Starmaxx",
            "Strial",
            "Sumitomo",
            "Taurus",
        ],
        [
            "Tourador",
            "Toyo",
            "Tracmax",
            "Trayal",
            "Trazano",
            "Trelleborg",
            "Triangle",
            "Tristar",
            "Unigrip",
            "Uniroyal",
            "Viking",
            "Voyager",
            "Vredestein",
            "Wanli",
            "Waterfall",
            "Windforce",
            "Yokohama"
        ]
    ]
</script>

<section class="brands d-none d-lg-block">
    <div class="container">
        <div class="row">
            <div class="col-12">
                <h2 class="section-title">Všetky značky</h2>
                <div class="row">
                    {#each brands as brands_group}
                        <div class="col-lg-2">
                            <ul class="brand-list">
                                {#each brands_group as brand}
                                    <li on:click={() => filter.set('manufacturer=' + encodeURIComponent(brand.replaceAll('¿', '�').replaceAll('ę', 'e').toUpperCase()))}>
                                        <a use:link href="/?manufacturer={encodeURIComponent(brand.replaceAll('¿', '�').replaceAll('ę', 'e').toUpperCase())}" on:click={() => window.scrollTo(0, 0)}>{brand}</a>
                                    </li>
                                {/each}
                            </ul>
                        </div>
                    {/each}
                </div>
            </div>
        </div>
    </div>
</section>

<style>
    .brands {
        font-family: Rubik, sans-serif;
        font-weight: 300;
    }
    .brands ul {
        padding-left: 1.5rem;
        list-style-image: url("/assets/img/icons/list-style.svg");
    }
    .brands ul li {
        border-right: 1px solid rgba(0, 0, 0, 0.07);
        margin-right: 50px;
    }
    .brands ul:last-child li {
        border-right: 0;
    }
    .brands ul li a {
        color: var(--color-slate-600);
        transition: .1s linear;
    }
    .brands ul li a:hover {
        color: #1A7ABA;
    }
</style>